/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Status_TitleInputs */



/**
* | output |
* | --- |
* | "Credentials configured" |
*
* @param {Integrations_Credentials_Status_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_status_title = /** @type {((inputs?: Integrations_Credentials_Status_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Status_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugangsdaten hinterlegt")
	return /** @type {LocalizedString} */ ("Credentials configured")
});